import axios from "axios"

export const nominatim = {
  async queryNominatimGeoCoordinates (url, callback) {
    axios({
      method: 'GET',
      url: process.env.VUE_APP_NOMINATIM_API + url + '&format=json'
    }).then(response => {
      callback(response);
    })
  }
}
